
















    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import QRcode from 'qrcodejs2'

    @Component
    export default class WeightImgInput extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;

        created() {
            //this.setQrCode(this.$store.state.backmainlandorder.orderNumber);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
               
                this.setQrCode(this.$store.state.backmainlandorder.orderNumber);
              
            }
        }
        setQrCode(val: string) {
            document.getElementById('weighimgup').innerHTML = "";
            let qrcode = new QRcode('weighimgup', {
                width: 150,
                height: 150, // 高度
                text: window.location.origin + "/#/takephone/uploadpackageimg?orderNumber=" + val, // 二维码内容
            });
        }
    }
